module.exports = __webpack_public_path__ + "img/privacy.97c0a852.png";